import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import ConfirmationModal from './ConfirmationModal';
import $ from 'jquery';
import editImg from "../../src/components/images/icon-edit.svg";
import delImg from "../../src/components/images/delete.svg";
import { WithContext as ReactTags } from 'react-tag-input';
import '../components/FetchData.css';
import Switch from "react-switch";
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import { Row, Col } from 'react-bootstrap';
import { TimeOutNotification } from './TimeOutNotification';
export class StudyManagement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            studiesList: [], timePointTagsObj: [], newTimePointTagsObj: [], checked: false, formSwitchChecked: false, isMsBase: [], show: false, modalName: '', studyNameList: [], studyNameSel: '', isMsBaseSel: false, timepointSel: [],
            expireMins: 0,
            sesExpNotMins: 0,
            marginTop: "-300px",
        };
        this.getAllStudies = this.getAllStudies.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.confirmUpdate = this.confirmUpdate.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.AddStudyId = this.AddStudyId.bind(this);
        this.startSessionTimeoutCounter = this.startSessionTimeoutCounter.bind(this);
    }
    componentDidMount() {
        window.addEventListener('mousemove', this.handleActivity);
        window.addEventListener('keydown', this.handleActivity);
        window.addEventListener('scroll', this.handleActivity);
       
        this.getAllStudies();
    }
    componentWillUnmount() {
        window.removeEventListener('mousemove', this.handleActivity);
        window.removeEventListener('keydown', this.handleActivity);
        window.removeEventListener('scroll', this.handleActivity);
    }
    handleActivity = () => {
        window['resetCountersOnEvent'](this.state.expireMins, this.state.sesExpNotMins);
    };
    startSessionTimeoutCounter() {
        this.setState({
            expireMins: parseInt(window.localStorage.getItem('ExpireMinutes')),
            sesExpNotMins: parseInt(window.localStorage.getItem('SessionExpireNotificationMinutes'))
        });
        window['startNotificationCounter'](this.state.expireMins, this.state.sesExpNotMins);
    }

    async getAllStudies() {
        await this.setState({
            loading: false
        }, () =>
            console.log(this.state));

        $.ajax({
            url: '/StudyManagement/GetAllStudies',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            success: function (data) {
                this.setState({
                    studiesList: data
                }, () => {
                    this.bindStudyTimepoints();
                   
               
                   
                });
            }.bind(this)
        });
    }
    async getIsMsBaseList() {
        var studyList = this.state.studiesList;
        var result = [];
        studyList.forEach(function (item, index) {
            result.push(item.isMsBase);
        });
        this.setState({
            isMsBase: result
        });
    }
    async getStudyNameList() {
        var studyList = this.state.studiesList;
        var result = [];
        studyList.forEach(function (item, index) {
            if (item.studyName != null)
                result.push(item.studyName);
        });

        await this.setState({
            studyNameList: result
        });
    }

    async bindStudyTimepoints() {
        $.ajax({
            url: '/StudyManagement/BindStudyTimepoint',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            success: function (data) {
                this.setState({
                    timePointTagsObj: data, loading: false
                });
                this.getIsMsBaseList();
                this.getStudyNameList();
                this.startSessionTimeoutCounter();
            }.bind(this)
        });
    }

    async handleChange(checked, index) {
        let isMsBase = [...this.state.isMsBase];
        isMsBase[index] = checked;
        this.setState({ isMsBase });
    }

    // Timepoint Tag Addition/Deletion for adding  new study
    handleTagAdditionNewStudy(tag, idx) {
        let newTimePointTagsObj = [...this.state.newTimePointTagsObj];
        if (newTimePointTagsObj[idx] === "undefined" || newTimePointTagsObj[idx] == null) {
            newTimePointTagsObj[idx] = []
        }

        newTimePointTagsObj[idx].push(tag);
        this.setState({ newTimePointTagsObj });
    }
    async handleTagDeletionNewStudy(i, idx) {
        var obj = this.state.newTimePointTagsObj[idx].filter((tag, index) => index !== i);
        var selectedTag = this.state.newTimePointTagsObj[idx][i].text;
        if (selectedTag === "unknown") {
            await this.setState({
                show: true,
                modalName: 'taginformationModal',
            },
                () =>
                    console.log(this.state));
            $("#okBtnId").hide();
        }

        else {
            let newTimePointTagsObj = [...this.state.newTimePointTagsObj];
            newTimePointTagsObj[idx] = obj;
            this.setState({
                newTimePointTagsObj
            });
        }
    }

    // Timepoint Tag Addition/Deletion on editing existing study
    handleTimepointTagAddition(tag, idx) {
        let timePointTagsObj = [...this.state.timePointTagsObj];
        if (timePointTagsObj[idx] === "undefined" || timePointTagsObj[idx] == null) {
            timePointTagsObj[idx] = []
        }

        timePointTagsObj[idx].push(tag);
        this.setState({ timePointTagsObj });
    }
    handleTimepointTagDeletion(i, idx) {
        var obj = this.state.timePointTagsObj[idx].filter((tag, index) => index !== i);
        $.ajax({
            url: '/StudyManagement/CheckIfTagExistInDB',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                rowID: idx,
                tagId: this.state.timePointTagsObj[idx][i].text
            },
            success: function (data) {
                if (data === true) {
                    let timePointTagsObj = [...this.state.timePointTagsObj];
                    timePointTagsObj[idx] = obj;
                    this.setState({
                        timePointTagsObj
                    });
                }

                else {
                    this.setState({
                        show: true,
                        modalName: 'taginformationModal',
                    },
                        () =>
                            console.log(this.state));
                    $("#okBtnId").hide();
                }
            }.bind(this)
        });
    }

    async updateStudy(id, itemId) {
        var timepointObj = this.state.timePointTagsObj[id];
        var newTimepointObj = [];
        timepointObj.forEach(function (item, index) {
            newTimepointObj.push(item.id);
        });

        await this.setState({
            show: true,
            studyId: itemId,
            studyNameSel: this.state.studyNameList[id],
            isMsBaseSel: this.state.isMsBase[id],
            modalName: 'updateConfirmModal',
            timepointSel: newTimepointObj
        },
            () =>
                console.log(this.state));
    }

    handleStudyNameChange(e, index) {
        let studyNameList = [...this.state.studyNameList];
        studyNameList[index] = e.target.value;
        this.setState({ studyNameList });
    }

    handleClose() {
        this.setState({
            show: false
        }, () =>
            console.log(this.state));
    }

    confirmUpdate() {
        $.ajax({
            url: '/StudyManagement/UpsertStudy',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                studyId: this.state.studyId,
                studyName: this.state.studyNameSel,
                isMsBase: this.state.isMsBaseSel,

                timepoint: JSON.stringify(this.state.timepointSel)
            },
            success: function (data) {
                this.setState({
                    studiesList: data
                });
                this.bindStudyTimepoints();
                this.getIsMsBaseList();
                this.getStudyNameList();
            }.bind(this)
        });
    }
    deleteStudy(id) {
        this.CheckLinkedWithOtherStudy(id);
    }

    CheckLinkedWithOtherStudy(studyid) {
        $.ajax({
            url: '/StudyManagement/CheckIfStudyLinked',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: { studyId: studyid },
            success: function (data) {
                var isStudyUsed = data;
                if (isStudyUsed) {
                    this.setState({
                        show: true,
                        studyId: studyid,
                        modalName: 'informationModal'
                    }, () =>
                        console.log(this.state));
                    $("#okBtnId").hide();
                }
                else {
                    this.setState({
                        show: true,
                        studyId: studyid,
                        modalName: 'deletConfirmModal'
                    }, () =>
                        console.log(this.state));
                }
            }.bind(this)
        });
    }

    confirmDelete() {
        $.ajax({
            url: '/StudyManagement/DeleteStudy',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                studyId: this.state.studyId,
            },
            success: function (data) {
                this.setState({
                    studiesList: data, loading: false
                });
                this.bindStudyTimepoints();
                this.getIsMsBaseList();
                this.getStudyNameList();
            }.bind(this)
        });
    }
    async handleFormSwitchChange(checked) {
        await this.setState({
            formSwitchChecked: checked
        }, () =>
            console.log(this.state));
    }
    async AddStudyId() {
        var valid = this.validateInput();
        if (valid) {
            var timepointObj = this.state.newTimePointTagsObj[0];
            var newTimepointObj = [];
            timepointObj.forEach(function (item, index) {
                newTimepointObj.push(item.id);
            });

            await this.setState({
                timepointSel: newTimepointObj
            }, () =>
                console.log(this.state));

            $.ajax({
                url: '/StudyManagement/UpsertStudy',
                type: 'GET',
                dataType: 'JSON',
                async: true,
                data: {
                    studyId: null,
                    studyName: $("#studyNameId").val(),
                    isMsBase: this.state.formSwitchChecked,
                    timepoint: JSON.stringify(this.state.timepointSel)
                },
                success: function (data) {
                    $("#content").hide();
                    $("#studyNameId").val("");
                    this.setState({
                        studiesList: data, loading: false, newTimePointTagsObj: [], formSwitchChecked: false
                    });
                    this.bindStudyTimepoints();
                    this.getIsMsBaseList();
                    this.getStudyNameList();
                    $("#errLabel").hide();
                }.bind(this)
            });
        }
    }
    validateInput() {
        if (!$("#studyNameId").val().replace(/\s/g, '').length) {
            $("#errLabel").show();
            return false;
        }
        else
            return true;
    }
    handleInputChange() {
        $("#errLabel").hide();
    }

    async CancelStudy() {
        $("#content").hide();
    }
    async getDefaultTimepointTags() {
        var obj = [];
        //obj.push({ "id": "unknown", "text": "unknown" });
        var defaultTimepoitnTagObj = [];
        defaultTimepoitnTagObj.push(obj);
        await this.setState({
            newTimePointTagsObj: defaultTimepoitnTagObj
        }, () =>
            console.log(this.state));
    }
    render() {
        return (
            <div>
                <Button variant="primary" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    $('#content').toggle();
                    { this.getDefaultTimepointTags() };
                }}>Add New Study</Button>
                <div id="content" style={{ background: "white", display: "none", height: "295px", width: "100%" }}>
                    <div style={{ background: "#133245", height: "45px", width: "100%" }}>
                    </div>
                    <Form>
                        <br />
                        <Container>

                            <Row>

                                <Col md={2}><Form.Label>Study Name</Form.Label></Col>
                                <Col md={4}>
                                    <Form.Control type="text" id="studyNameId" style={{
                                        height: "38px", width: "80%"
                                    }}
                                        onChange={this.handleInputChange.bind(this)}
                                    />

                                </Col>

                            </Row>
                            <Row>

                                <Col md={2}><Form.Label>IsMsBase</Form.Label></Col>
                                <Col md={4}>
                                    <Switch

                                        checked={this.state.formSwitchChecked}
                                        onChange={(e) => this.handleFormSwitchChange(e)}
                                        onColor='#50b4e2'
                                        offColor='#D3D3D3'
                                        uncheckedIcon={
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%",
                                                    fontSize: 15,
                                                    color: "black",
                                                    paddingRight: 2
                                                }}
                                            >
                                                No
                                            </div>
                                        }

                                        checkedIcon={
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%",
                                                    fontSize: 15,
                                                    color: "white",
                                                    paddingRight: 2
                                                }}
                                            >
                                                Yes
                                            </div>
                                        }
                                    />                                </Col>

                            </Row>
                            <Row>

                                <Col md={2}><Form.Label>Timepoints</Form.Label></Col>
                                <Col md={4}>
                                    <ReactTags id={"newTimepointTagId"}
                                        tags={this.state.newTimePointTagsObj[0] || []}

                                        handleAddition={(e) => this.handleTagAdditionNewStudy(e, 0)}
                                        handleDelete={(e) => this.handleTagDeletionNewStudy(e, 0)}

                                        className="form-control"
                                        inputFieldPosition="top"
                                        allowUnique={true}
                                        style={{ height: "38px" }}

                                    />
                                </Col>

                            </Row>

                            <Row>
                                <Col md={2}></Col>
                                <Col md={4}><table><tbody><tr><td><Button variant="secondary" id="cancelStudy" onClick={this.CancelStudy}>Cancel</Button></td>
                                    <td width="12px"></td><td><Button variant="primary" id="addStudy" onClick={this.AddStudyId}>Add</Button></td></tr></tbody></table></Col>
                                <label id="errLabel" style={{ color: "red", display: "none" }}>*Input Required</label>
                            </Row>
                        </Container>
                    </Form>
                </div>

                <div>

                    <table className='table table-striped' aria-labelledby="tabelLabel" style={{ width: "100%", tableLayout: "fixed" }}>
                        <thead style={{ backgroundColor: "#1861ac" }}>
                            <tr>
                                <th style={{ width: "23%" }}>Study Name</th>
                                <th style={{ width: "26%" }}>MSBase Study</th>
                                <th style={{ width: "15%" }}>Timepoint</th>
                                <th style={{ width: "10%" }}>Update</th>
                                <th style={{ width: "25%" }}>Delete</th>

                            </tr>
                        </thead>
                        <tbody>
                            {this.state.studiesList.map((item, idx) =>
                                <tr key={item.id}>
                                    <td><input type="text" onChange={(e) => this.handleStudyNameChange(e, idx)} defaultValue={item.studyName} id={'name' + idx} style={{ height: "38px", width: "70%" }} /></td>
                                    <td>
                                        <Switch
                                            onChange={(e) => this.handleChange(e, idx)}
                                            checked={this.state.isMsBase[idx] || item.isMsBase}
                                            onColor='#50b4e2'
                                            offColor='#D3D3D3'
                                            uncheckedIcon={
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: "black",
                                                        paddingRight: 2
                                                    }}
                                                >
                                                    No
                                                </div>
                                            }

                                            checkedIcon={
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: "white",
                                                        paddingRight: 2
                                                    }}
                                                >
                                                    Yes
                                                </div>
                                            }
                                        />
                                    </td>
                                    <td>
                                        <ReactTags id={"study" + idx}
                                            tags={this.state.timePointTagsObj[idx] || []}
                                            handleAddition={(e) => this.handleTimepointTagAddition(e, idx)}
                                            handleDelete={(e) => this.handleTimepointTagDeletion(e, idx)}
                                            className="form-control"
                                            inputFieldPosition="top"
                                            allowUnique={true}
                                            style={{ height: "38px" }}

                                        />
                                    </td >

                                    <td>
                                        <Button variant="primary"
                                            onClick={(e) => this.updateStudy(idx, item.id)}
                                        >

                                            <img src={editImg} alt="" />
                                        </Button>{' '}
                                    </td>
                                    <td>
                                        <Button variant="primary" value={item.id} onClick={(e) => this.deleteStudy(item.id)}>
                                            <img src={delImg} alt="" />

                                        </Button>{' '}
                                    </td>

                                </tr>

                            )}
                        </tbody>
                    </table>

                </div>
                <ConfirmationModal
                    stateProps={this.state}
                    handleClose={this.handleClose}
                    confirmUpdate={this.confirmUpdate}
                    confirmDelete={this.confirmDelete}
                />
                <TimeOutNotification
                    sessionState={this.state}

                />
            </div>

        );
    }
}